import { RotarySteerableFactorBase } from './base/rotary-steerable-factor-base';

export class RotarySteerableFactor extends RotarySteerableFactorBase { }